import React, { ReactNode } from "react";

import LoadingSpinner from "./components/LoadingSpinner";
import CheckAccountState from "./components/CheckAccountState";
import AppLayout from "./components/AppLayout";

import { PermissionsProvider } from "modules/user/config/permissions/Can";

import { useUserLocalProjectsQuery } from "modules/projects/hooks/queries/useUserLocalProjectsQuery";
import { useNotificationsQuery } from "./hooks/queries/useNotificationsQuery";
import { useAuthUserQuery } from "../user/hooks/queries/useAuthUserQuery";
import { useRollupsQuery } from "modules/projects/hooks/queries/useRollupsQuery";
import { useFeatureModulesQuery } from "modules/user/hooks/queries/useFeatureModulesQuery";

interface IProps {
  children: ReactNode;
}

const App: React.FC<IProps> = ({ children }) => {
  const { data: userData, isLoading: isAuthUserDataLoading } =
    useAuthUserQuery();
  const { data: projectsData, isLoading: isProjectsLoading } =
    useUserLocalProjectsQuery();
  const { data: rollupsData, isLoading: isRollupsLoading } = useRollupsQuery();
  const { data: featureModules, isLoading: isFeatureModulesLoading } =
    useFeatureModulesQuery();

  const { isLoading: isNotificationsLoading } = useNotificationsQuery();

  const isAppLoading =
    isAuthUserDataLoading ||
    isProjectsLoading ||
    isRollupsLoading ||
    isNotificationsLoading ||
    isFeatureModulesLoading;

  if (isAppLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (userData && projectsData && rollupsData && featureModules) {
    return (
      <PermissionsProvider>
        <CheckAccountState>
          <AppLayout>{children}</AppLayout>
        </CheckAccountState>
      </PermissionsProvider>
    );
  }

  return null;
};

export default React.memo(App);
